<template>
  <div>
    <QS-h4-title title="订单收款信息" />
    <!-- 收款信息列表 -->
    <QS-common-table
      v-loading="loading"
      :columns="columns"
      :pagination="pagination"
      :data="list"
      @change="pageChange"
      @selection-change="
        (selectedItems) => {
          this.receiptSelectedItems = selectedItems
        }
      "/>
  </div>
</template>

<script>
import { getReceivableList } from '@/api/domain/returnLease'
import selectOption from '@/store/dict/selectOptionDict'
import config from './config'
import { mapState } from 'vuex'

export default {
  inject: ['orderData'],
  data() {
    const { columns, pagination } = config.call(this)
    return {
      columns,
      pagination,
      loading: false,
      // 收款被选中项
      // eslint-disable-next-line vue/no-unused-properties
      receiptSelectedItems: [],
      list: [],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.getReceivableList()
  },
  methods: {
    // 应收列表
    async getReceivableList() {
      this.loading = true
      const { code, data } = await getReceivableList({
        sourceOrderId: this.orderData.id,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      })
      this.loading = false
      if (code !== 1) return
      this.list = data.items
        ? data.items.map((item) => {
          return {
            ...item,
            changeState: selectOption.payeechange[item.changeState],
            receivableState: selectOption.completionStatusDict[item.receivableState],
            content: this.formatEnumeration(this.freeTypeList)[item.content],
          }
        })
        : []
      this.pagination.total = data.totalNum
    },
    pageChange(payload) {
      this.pagination.pageNum = payload.pagination.pageNum
      this.pagination.pageSize = payload.pagination.pageSize
      this.getReceivableList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .disableSelection .cell .el-checkbox__inner {
    display: inline-block;
    position: relative;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-color: #DCDFE6;
    background-color: #F5F7FA;
    cursor: not-allowed;
    z-index: 1;
}
</style>
